export const legal = {
  legalNotice: {
    title: 'Legal Notice',
    lastUpdate: 'Last updated: January 2026',
    content: 'Legal notice content in English...'
  },
  privacy: {
    title: 'Privacy Policy',
    lastUpdate: 'Last updated: January 2026',
    content: 'Privacy policy content in English...'
  },
  cookies: {
    title: 'Cookie Policy',
    lastUpdate: 'Last updated: January 2026',
    content: 'Cookie policy content in English...'
  }
};
